// extracted by mini-css-extract-plugin
export default {"lesson":"I_L5f","title":"NVrq2"};